import { SurveyDefinition, SurveyStepDefinition } from "../../../types/Survey";

export function getProgressIndicatorType(survey: SurveyDefinition, step: SurveyStepDefinition) {
    if (survey.steps.length == 1 || step.excludeFromProgressCalculation) {
        return 'None';
    }

    //default behavior
    if (!survey.progressIndicatorType) {
        if (survey.type === 'RKStudioNavigableOrderedTask') {
            return 'None';
        }
        return 'Text';
    }

    return survey.progressIndicatorType;
}

export function getNextButtonStyles(survey: SurveyDefinition, step: SurveyStepDefinition) {
    const resolvedStyles = { ...survey.styles, ...step.styles };

    var backgroundImage = null;
    var gradient = resolvedStyles.nextButtonBackgroundGradient;
    if (gradient) {
        var direction = gradient.direction;
        if (direction == "LeftToRight") {
            backgroundImage = "linear-gradient(to right, " + gradient.startColor + " 0%," + gradient.endColor + " 100%)";
        } else {
            backgroundImage = "linear-gradient(to bottom, " + gradient.startColor + " 0%," + gradient.endColor + " 100%)";
        }
    }

    var letterSpacing = resolvedStyles.nextButtonLetterSpacing;
    var textTransform = resolvedStyles.nextButtonTextTransform;
    var fontWeight = resolvedStyles.nextButtonFontWeight;
    let backgroundColor = resolvedStyles.nextButtonBackgroundColor;

    return {
        "letter-spacing": letterSpacing ? letterSpacing + "px" : null,
        "text-transform": textTransform ? textTransform.toLowerCase() : null,
        "color": resolvedStyles.nextButtonTextColor,
        "background-color": backgroundColor,
        "background-image": backgroundImage,
        "border-color": backgroundColor,
        "font-weight": fontWeight ? fontWeight.toLowerCase() : null
    };
}

export function getBackgroundStyles(survey: SurveyDefinition, step: SurveyStepDefinition,) {
    const resolvedStyles = { ...survey.styles, ...step.styles };
    if (!getFormStyle(survey, step)) {
        return {
            "background-color": "#FFFFFF"
        };
    }
    if (getFormStyle(survey, step) == "cardBased" && resolvedStyles.backgroundColor) {
        return {
            "background-color": "#F5F5F5"
        };
    }
    return {
        "background-color": resolvedStyles.backgroundColor
    };
}

export function getFormStyle(survey: SurveyDefinition, step: SurveyStepDefinition,) {
    if (survey.useWebSurveyEngine) {
        return "v2";
    }
    return { ...survey.styles, ...step.styles }.formStyle;
}

export function getTextStyles(element: "title" | "text" | "detailText" | "footnote", survey: SurveyDefinition, step: SurveyStepDefinition, react: boolean) {
    const resolvedStyles = { ...survey.styles, ...step.styles };
    function extractStyles(color?: string, fontSize?: string, fontWeight?: string, textAlign?: string) {
        if (!react) {
            return {
                "color": color,
                "font-size": fontSize ? fontSize + "px" : null,
                "font-weight": fontWeight ? fontWeight.toLowerCase() : null,
                "text-align": textAlign ? textAlign.toLowerCase() : null
            }
        } else {
            return {
                color: color,
                fontSize: fontSize ? fontSize + "px" : null,
                fontWeight: fontWeight ? fontWeight.toLowerCase() : null,
                textAlign: textAlign ? textAlign.toLowerCase() as "left" | "right" | "center" | "justify" : null
            } as React.CSSProperties;
        }
    }

    if (element == "title") {
        return extractStyles(resolvedStyles.titleColor, resolvedStyles.titleFontSize, resolvedStyles.titleFontWeight, resolvedStyles.titleAlignment);
    }
    else if (element == "detailText") {
        return extractStyles(resolvedStyles.detailTextColor, resolvedStyles.detailTextFontSize, resolvedStyles.detailTextFontWeight, resolvedStyles.detailTextAlignment);
    }
    else if (element == "footnote") {
        return extractStyles(resolvedStyles.footnoteColor, resolvedStyles.footnoteFontSize, resolvedStyles.footnoteFontWeight, resolvedStyles.footnoteAlignment);
    }
    return extractStyles(resolvedStyles.textColor, resolvedStyles.textFontSize, resolvedStyles.textFontWeight, resolvedStyles.textAlignment);
}